module.exports = __webpack_public_path__ + "img/caas4m-m@2.66ec926f.webp";